module.exports = __webpack_public_path__ + "static/media/desert-world-small.140cf083.jpg";